import { UserEndpoints } from '@/services/shared/ApiEndpoints';
import { API } from '@/utils/api';

class UserService {
  /**
   * Changes the user's password.
   */
  async changePassword(passwordData: any) {
    try {
      const response = await API.post(UserEndpoints.CHANGE_PASSWORD, passwordData);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Wystąpił problem ze zmianą hasła:', error);
      return { success: false, error: error.response?.data || error.message };
    }
  }

  /**
   * Switches the tenant for the current user.
   * Returns { success: true, tenantId } on success.
   */
  async switchTenant(newTenantId: string | null) {
    try {
      const response = await API.put(UserEndpoints.SWITCH_TENANT, { newTenantId });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Wystąpił problem ze zmianą tenanta:', error);
      return { success: false, error: error.response?.data || error.message };
    }
  }
}

const instance = new UserService();
export { instance as UserService };
